import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const OfferSection: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-gradient-to-b from-lavender to-white px-6 py-16 md:py-24" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="flex items-center justify-center gap-4 mb-12" data-id="element-75">
          <div className="h-px bg-gray-300 flex-1 max-w-[100px]" data-id="element-76"></div>
          <span className="text-gray-500 font-medium uppercase tracking-wider text-sm" data-id="element-77">
            La solución para tu nivel
          </span>
          <div className="h-px bg-gray-300 flex-1 max-w-[100px]" data-id="element-78"></div>
        </div>

        <div className="flex justify-center mb-10" data-id="element-79">
          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="bg-brand-red text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg" data-id="element-80">
            ⚡ OFERTA ESPECIAL PARA TU RESULTADO
          </motion.div>
        </div>

        <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-81">
          {/* Copy Column */}
          <div className="flex-1 order-2 md:order-1" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-extrabold text-dark-blue mb-3" data-id="element-83">
              Protocolo Mente Serena
            </h2>
            <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-84">
              La guía creada exactamente para tu nivel de ansiedad
            </p>

            <ul className="space-y-4 mb-10" data-id="element-85">
              {['El método de 5 minutos para calmar la mente al instante', 'Plan de 21 días adaptado a tu nivel', 'Kit de emergencia mental', 'Técnicas de respiración que funcionan en segundos', 'Rutina diaria de 10 minutos', 'Plan de alimentación anti-ansiedad 7 días', '4 Bonus gratis incluidos'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-700 font-medium" data-id="element-86">
                  <span className="text-xl shrink-0" data-id="element-87">✅</span>
                  <span data-id="element-88">{item}</span>
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-89">
              <div className="flex items-baseline gap-3 mb-1" data-id="element-90">
                <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-91">
                  $15.99
                </span>
                <span className="text-5xl text-brand-red font-extrabold" data-id="element-92">
                  $9.99
                </span>
              </div>
              <p className="text-brand-red font-semibold text-sm" data-id="element-93">
                ⏰ Precio especial por tiempo limitado
              </p>
            </div>

            <div className="bg-white border-2 border-brand-red rounded-xl p-4 mb-6 text-center shadow-sm" data-id="element-94">
              <span className="font-mono text-3xl font-bold text-dark-blue tracking-wider" data-id="element-95">
                {formatTime(timeLeft.h)}:{formatTime(timeLeft.m)}:
                {formatTime(timeLeft.s)}
              </span>
            </div>

            <a href="https://www.tumundoequilibrado.com/cart/51445241872679:1" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-brand-red hover:bg-red-600 text-white font-black text-xl py-5 rounded-2xl shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-96">
              QUIERO MI PROTOCOLO AHORA — $9.99 →
            </a>

            <p className="text-center text-sm text-gray-500 font-medium" data-id="element-97">
              🔒 Pago seguro | 📥 Descarga inmediata | 🛡️ Garantía 7 días
            </p>
          </div>

          {/* Image Column */}
          <div className="flex-1 order-1 md:order-2 w-full max-w-md" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/44Lf2nxndS5XmzEF5sDsXi/a-realistic-photographic-ebook-cover-in-_R4t3IlyGViuavcA5OjMGvA_9fqzUc-VTtW6YlomZWCYiw.jpg" alt="Protocolo Mente Serena Ebook" className="w-full rounded-2xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-99" />
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-100">
          {[{
          name: 'María G.',
          loc: 'Miami, FL',
          level: 'Nivel 3 como tú',
          text: 'Dormí completa por primera vez en años',
          img: 'https://i.pravatar.cc/150?img=47'
        }, {
          name: 'Carmen R.',
          loc: 'Houston, TX',
          level: 'Nivel 2',
          text: 'Por fin algo que habla de nosotras las latinas',
          img: 'https://i.pravatar.cc/150?img=44'
        }, {
          name: 'Valentina M.',
          loc: 'Chicago, IL',
          level: 'Nivel 3 como tú',
          text: 'Mi familia nota el cambio en 2 semanas',
          img: 'https://i.pravatar.cc/150?img=49'
        }].map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-101">
              <div className="text-yellow-400 text-lg mb-3" data-id="element-102">⭐⭐⭐⭐⭐</div>
              <p className="text-gray-700 font-medium italic mb-4" data-id="element-103">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-104">
                <img src={t.img} alt={t.name} className="w-10 h-10 rounded-full" data-id="element-105" />
                <div data-id="element-106">
                  <p className="font-bold text-dark-blue text-sm" data-id="element-107">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-108">
                    {t.loc} · {t.level}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="bg-green-50 border border-green-200 rounded-2xl p-6 flex items-center justify-center gap-4 text-green-800 font-semibold text-center md:text-left" data-id="element-109">
          <span className="text-3xl" data-id="element-110">🛡️</span>
          <p data-id="element-111">Garantía total de 7 días — Si no te ayuda te devolvemos el 100%</p>
        </div>
      </div>
    </div>;
};